import { render, staticRenderFns } from "./MainSelect.vue?vue&type=template&id=4c00b568&scoped=true&"
import script from "./MainSelect.vue?vue&type=script&lang=js&"
export * from "./MainSelect.vue?vue&type=script&lang=js&"
import style0 from "./MainSelect.vue?vue&type=style&index=0&id=4c00b568&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c00b568",
  null
  
)

export default component.exports